module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_hokkaido-71e42f20b95e2a55dbb6530031c88d49.jpg";